module.exports = __webpack_public_path__ + "static/media/SuraDelta.2a1a9c78.svg";